import { render } from "./CreateUser.vue?vue&type=template&id=c1aa1aa8&scoped=true"
import script from "./CreateUser.vue?vue&type=script&lang=js"
export * from "./CreateUser.vue?vue&type=script&lang=js"

import "./CreateUser.vue?vue&type=style&index=0&id=c1aa1aa8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1aa1aa8"]])

export default __exports__